module.exports = __webpack_public_path__ + "img/3.6802cfe8.jpg";